// extracted by mini-css-extract-plugin
module.exports = {"back-to-top":"BackToTop_back-to-top__X8uGC"};